export enum FontSource {
  Local = 'local',
}
